import Vue from 'vue'
import router from '../../../router'
import moment from 'moment'

export const promoRealizations = {
    state: {
        status: 'idle',
        promoRealizationsExportStatus: 'idle',
        promotionRealizations: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        sortOptions: [
            {
                query: 'promoId',
                label: 'ID promocji'
            },
            {
                query: 'name',
                label: 'Promocja'
            },
            {
                query: 'status',
                label: 'Status'
            }
        ],
        sort: {
            by: 'promoId',
            direction: 'desc'
        },
        disabledPromoTypes: ['Promo::Advertisement'],
        filters: {
            status: {
                type: 'radio',
                value: null,
                text: 'Status',
                options: [
                    {
                        label: 'Wyniki dla wszystkich promocji',
                        value: false
                    },
                    {
                        label: 'Wyniki dla aktywnych promocji',
                        value: true
                    }
                ]
            },
            dates: {
                type: 'dates',
                value: '',
                text: 'Data użycia',
                lockFutureDays: [moment().format('YYYY-MM-DD')],
                lockRangeDaysNumber: 31
            },
            shopIds: {
                type: 'ui-virtual-list',
                value: [],
                multi: true,
                searcher: false,
                label: 'Wybierz sklep',
                moduleName: 'merchants',
                fetchAction: 'merchantsFetch',
                getter: 'getDevicesShopsForSelect',
                disabledLinkGenerator: true
            },
            producerId: {
                type: 'ui-virtual-list',
                moduleName: 'companies',
                value: null,
                searcher: false,
                getter: 'getCompaniesForFilters',
                label: 'Organizator'
            },
            promotionId: {
                type: 'ui-virtual-list',
                value: null,
                moduleName: 'promotions',
                getter: 'getPromotionsForFilters',
                label: 'Promocja'
            },
            productNames: {
                type: 'ui-virtual-list',
                value: [],
                searcher: true,
                multi: true,
                moduleName: 'products',
                getter: 'getProductNamesForFilters',
                label: 'Produkt'
            },
            promotionType: {
                type: 'ui-virtual-list',
                value: null,
                searcher: false,
                moduleName: 'promotions',
                getter: 'getPromoTypesForPromoRealizationsFilters',
                label: 'Typ promocji',
                firstOption: 'Wszyscy'
            }
        }
    },
    mutations: {
        SET_PROMOREALIZATIONS_STATUS(state, payload) {
            state.status = payload
        },
        SET_PROMOREALIZATIONS(state, payload) {
            state.promotionRealizations = payload
        },
        SET_PROMOREALIZATIONS_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_PROMOREALIZATIONS_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_PROMOREALIZATIONS_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_PROMOREALIZATIONS_PERPAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_PROMOREALIZATIONS_FILTER(state, payload) {
            Vue.set(
                state.filters[payload.filter],
                payload.key || 'value',
                payload.value
            )
        },
        RESET_PROMOREALIZATIONS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_PROMOREALIZATIONS_SORT(state, payload) {
            state.sort = payload
        },
        SET_PROMOREALIZATIONS_PAGINATION(state, payload) {
            state.pagination = {
                ...state.pagination,
                ...payload
            }
        },
        SET_PROMOREALIZATIONS_EXPORT_STATUS(state, payload) {
            state.promoRealizationsExportStatus = payload
        }
    },
    actions: {
        getPromoRealizationReport({ commit, state, getters }) {
            commit('SET_PROMOREALIZATIONS_EXPORT_STATUS', 'loading')

            const paging = {
                orderDirection: state.sort.direction.toUpperCase(),
                orderBy: state.sort.by,
                numberOfPage: 0,
                numberOfRows: state.pagination.totalRecords
            }
            const params = {
                paging,
                ...getters.getPromoRealizationQueryParams
            }
            if (!params.startDate || !params.endDate) {
                params.startDate = Vue.moment()
                    .subtract(
                        state.filters.dates.lockRangeDaysNumber - 1,
                        'days'
                    )
                    .format('YYYY-MM-DD HH:mm')
                params.endDate = Vue.moment().format('YYYY-MM-DD HH:mm')
            }
            return this.$api
                .post('promotionRealisationXlsx', params, {
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    const today = Vue.moment().format('YYYY-MM-DD HH:mm')

                    const fileLink = document.createElement('a')
                    const blob = new Blob([response.data], {
                        type: '"application/octet-stream"'
                    })
                    fileLink.href = window.URL.createObjectURL(blob)
                    fileLink.download = `Realizacja promocji-${today}.xlsx`
                    fileLink.click()
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    commit('SET_PROMOREALIZATIONS_EXPORT_STATUS', 'idle')
                })
        },
        promoRealizationsFetch({ commit, state, getters }) {
            commit('SET_PROMOREALIZATIONS_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_PROMOREALIZATIONS_CURRENT',
                    +router.currentRoute.query.page
                )
            }
            if (router.currentRoute.query.show) {
                commit(
                    'SET_PROMOREALIZATIONS_PERPAGE',
                    +router.currentRoute.query.show
                )
            }

            const pagination = {
                orderDirection: state.sort.direction.toUpperCase(),
                orderBy: state.sort.by,
                numberOfPage: state.pagination.page - 1,
                numberOfRows: state.pagination.perPage
            }
            const params = {
                paging: pagination,
                ...getters.getPromoRealizationQueryParams
            }

            return this.$api
                .post('reports/promotionRealization', params)
                .then(res => {
                    if (res && res.data && res.data.data) {
                        const totalPages = Math.ceil(
                            res.data.data.paging.count /
                                state.pagination.perPage
                        )

                        commit('SET_PROMOREALIZATIONS_PAGINATION', {
                            totalPages,
                            totalRecords: res.data.data.paging.count
                        })

                        commit(
                            'SET_PROMOREALIZATIONS',
                            res.data.data.promotions
                        )
                    } else {
                        commit('SET_PROMOREALIZATIONS', null)
                        commit('SET_PROMOREALIZATIONS_PAGINATION', {
                            page: 1,
                            totalPages: 0,
                            totalRecords: 0
                        })
                    }
                    commit('SET_PROMOREALIZATIONS_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_PROMOREALIZATIONS_STATUS', 'idle')
                    }
                })
        },
        async promoRealizationsFiltersFetch({ dispatch, getters }) {
            await dispatch('companiesFetch')
        },
        setPromoRealizationsSort({ commit }, payload) {
            commit('SET_PROMOREALIZATIONS_SORT', payload)
        },
        setPromoRealizationsPagination({ commit }, payload) {
            commit('SET_PROMOREALIZATIONS_PAGINATION', payload)
        }
    },
    getters: {
        getPromoRealizationQueryParams: (state, allGetters) => {
            const shopIds = allGetters.getLocationIds
                ? allGetters.getLocationIds
                : []

            let startDate = null
            let endDate = null

            if (state.filters.dates.value) {
                const dates = state.filters.dates.value.split(',')
                startDate = `${dates[0]} 00:00`
                endDate = `${dates[1]} 23:59`
            }

            return {
                promotionId: state.filters.promotionId.value,
                producerId: state.filters.producerId.value,
                promotionType: state.filters.promotionType.value,
                shopIds:
                    state.filters.shopIds.value.length > 0
                        ? state.filters.shopIds.value
                        : shopIds,
                startDate,
                endDate,
                status: state.filters.status.value,
                productNames: state.filters.productNames.value
                    ? state.filters.productNames.value
                    : []
            }
        },
        getPromoRealizations: state => {
            return state.promotionRealizations
        },
        getPromoRealizationsStatus: state => {
            return state.status
        },
        getPromoRealizationsPagination: state => {
            return state.pagination
        },
        getPromoRealizationsFilters: state => {
            return state.filters
        },
        getPromoRealizationsSort: state => {
            return state.sort
        },
        getPromoRealizationsSortOptions: state => {
            return state.sortOptions
        },
        getPromoTypesForPromoRealizationsFilters: (state, getters) => {
            // all promos from getters.getPromoTypes but without state.disabledPromoTypes
            const availableTypes = getters.getPromoTypes.filter(
                item => !state.disabledPromoTypes.includes(item.type)
            )

            return getters.getPromoTypesForFilters(availableTypes)
        },
        getPromoRealizationsExportStatus: state => {
            return state.promoRealizationsExportStatus
        }
    }
}
